<template>
    <div>
        <table class="table">
            <thead>
                <tr>
                    <th>#</th>
                    <th>{{ t('Seller') }}</th>
                    <th>{{ t('Product') }}</th>
                    <th>{{ t('Promotions') }}</th>
                    <th style="width:100px;">{{ t('7-Day sales') }}</th>
                    <th style="width:90px;">{{ t('Price') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, index) in rows">
                    <td>{{ index+1 }}</td>
                    <td>{{ row.seller_name }}</td>
                    <td><a :href="row.link" target="_blank">{{ row.name }}</a></td>
                    <td>
                        <img v-if="row.highlight_promo == 1" class="promo" src="../../assets/img/promotion_highlight.png" v-bind:title="t('Highlighted')" />
                        <img v-if="row.featured_promo == 1" class="promo" src="../../assets/img/promotion_featured.png" v-bind:title="t('Featured')" />
                        <img v-if="row.bold_promo == 1" class="promo" src="../../assets/img/promotion_strong.png" v-bind:title="t('Bold')" />
                        <img v-if="row.categories_promo == 1" class="promo" src="../../assets/img/promotion_category.png" v-bind:title="t('Highlighted on category page')" />
                        <img v-if="row.homepage_promo == 1" class="promo" src="../../assets/img/promotion_homepage.png" v-bind:title="t('Highlihted on homepage')" />
                    </td>
                    <td>{{ row.quantity_sold_per_week }}</td>
                    <td>{{ row.price }}</td>
                </tr>
            </tbody>
        </table>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                rows: [],
            };
        },
        mounted() {
            this.init();
        },
        methods:
        {
            getTableId: function() {

            },
            init: function() {
                const v = this;

                console.log(this.$data.rows);
                this.rows = this.$data.rows;

            },
        }
    }
</script>

<style scoped>
    .promo {
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// details.vue?c7b8f512